import { render, staticRenderFns } from "./WarningsPanelNew.vue?vue&type=template&id=ac2d599a&"
import script from "./WarningsPanelNew.vue?vue&type=script&lang=js&"
export * from "./WarningsPanelNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports